import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
} from "@mui/material";

import { ReactComponent as IconDelete } from "../../assets/svg/delete.svg";
import { TEXT } from "../../constants/text";

export function DeleteConfirmationDialog({
  open,
  onClose,
  onDelete,
  name,
  type,
}) {

  const mainText = type === 'runner' ? TEXT.sidebarResults.deleteConfirm1 : TEXT.planner.deleteConfirm1
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        sx={{
          ".MuiDialog-paper": {
            maxWidth: "440px",
            width: "440px",
            borderRadius: "12px",
            padding: "24px",
            background: '#FBFBFD'
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <IconDelete width={'32px'} height={'32px'} fill='#ba1a1a' />
            <Typography textAlign={"center"} fontSize={"18px"} fontWeight={600}>
              Delete {name}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography textAlign={"center"} fontWeight={400} color={"#5D5F6A"}>
              {mainText}
            </Typography>
            <Typography textAlign={"center"} fontWeight={400} color={"#5D5F6A"}>
              {TEXT.planner.deleteConfirm2}
            </Typography>
            {/*  <Typography fontWeight={400} color={"#5D5F6A"}>
              <span style={{ color: "red" }}>{name}</span>?
            </Typography>
            <Typography fontWeight={400} color={"#5D5F6A"}>
              This action cannot be undone.
            </Typography> */}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={onClose}
            sx={{
                width: "100%",
                background: "#fff",
                color: "#343745",
                textTransform: "none",
                boxShadow: 3,
                ":hover": {
                  boxShadow: 6,
                },
              }}
          >
            Cancel
          </Button>
          <Button
            onClick={onDelete}
            sx={{
                marginLeft: 24, 
                width: "100%",
                background: "#ba1a1a",
                color: "#fff",
                textTransform: "none",
                boxShadow: 3,
                ":hover": {
                  boxShadow: 6,
                },
              }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Backdrop open={open} style={{ zIndex: 1200 }}>
        <Paper
          elevation={3}
          style={{
            padding: "24px",
            width: "400px",
            textAlign: "center",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "top",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <IconDelete />
              <Typography fontSize={"18px"} fontWeight={600}>
                Delete {name}
              </Typography>
            </Box>
            <Typography fontWeight={400} color={"#5D5F6A"}>
              Are you sure you want to delete this {type}? This action cannot be
              undone.
            </Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              marginTop={2}
              gap={2}
            >
              <Button
                variant="outlined"
                onClick={onClose}
                style={{ flexGrow: 1 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={onDelete}
                style={{ flexGrow: 1 }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </Paper>
      </Backdrop> */}
    </>
  );
}

function App() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDelete = () => {
    setIsDialogOpen(false);
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleOpenDialog}>
        Open Delete Confirmation
      </Button>
      <DeleteConfirmationDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onDelete={handleDelete}
      />
    </div>
  );
}
